import ContentCard from "./ContentCard"

export default function OneVideo({ data }) {
  return <ContentCard data={data} type="Video" viewer="view-video" />
}
